import { h, Component } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control'
import RadioInputGroup from '../ui-components/RadioInputGroup'
import Textarea from '../ui-components/Textarea'
import { common } from '../common'
import axios from 'axios'
import InputGroup from '../ui-components/InputGroup'
import GroupSelector, { Group } from '../groups/GroupSelector'

type Props = {
  importId: string,
  isOpen: boolean,
  contactCount: number,
  onClose: () => void,
  onContactsInvited: (success: boolean, isGroupInvite: boolean) => void
}

type State = {
  inviteType: string,
  inviteTypeChoices: string[],
  groupId?: number,
  groups: Group[],
  selectGroupError: string,
  customMessage: string
}

const joinCommunity = 'Join community'
const joinCommunityAndGroup = 'Join community and a group'

class ContactInviteModal extends Component<Props, State> {
  constructor (props: Props) {
    super(props)
    this.setState({
      inviteType: joinCommunity,
      inviteTypeChoices: [joinCommunity],
      customMessage: '',
      selectGroupError: '',
      groups: []
    })

    this.sendInvite = this.sendInvite.bind(this)
  }

  async componentDidMount () {
    if (!common.isModuleActive('group')) {
      return
    }
    await axios.get('/group/list')
      .then((res) => {
        this.setState({
          groups: res.data as Group[],
          inviteTypeChoices: [joinCommunity, joinCommunityAndGroup]
        })
      })
      .catch(() => {})
  }

  async sendInvite () {
    const { inviteType, groupId, customMessage } = this.state

    if (inviteType === joinCommunityAndGroup && !groupId) {
      this.setState({ selectGroupError : 'Please select a group.'})
      return
    }

    const isGroupInvite = inviteType === joinCommunityAndGroup

    await axios
      .post('/contact/invite', {
        'customMessage': customMessage,
        'groupId': isGroupInvite ? groupId : null,
        'importId': this.props.importId
      })
      .then(res => {this.props.onContactsInvited(true, isGroupInvite)})
      .catch(() => this.props.onContactsInvited(false, isGroupInvite))
  }

  render ({ isOpen, contactCount, onClose }:Props, { inviteTypeChoices, inviteType, selectGroupError, customMessage, groups, groupId }:State) {
    return (
      <Modal isOpen={isOpen} size='medium'>
        <ModalHeader title={`Send invite to ${contactCount} contact${contactCount > 1 ? 's' : ''}`} onClose={() => onClose()} />
        <ModalBody>
          <div className='contact-invite-modal'>
            <RadioInputGroup
              title={'Invite contacts to'}
              options={inviteTypeChoices}
              onChange={(option) => this.setState({ inviteType: option, selectGroupError: '' })}
              value={inviteType}
              underneath
            />
            {groups.length > 0 && <div className='group-select-wrapper'>
              <InputGroup
                customInput={<GroupSelector
                  groups={groups}
                  onGroupSelected={(groupId: number) => this.setState({ groupId, selectGroupError: '' })}
                  disabled={inviteType === joinCommunity}
                />}
                error={selectGroupError}
              />
            </div>}
            <label className='contact-invite-modal__textarea-label'>Invite message</label>
            <div>It’s more likely for people to accept an invite if there is a personalised message attached.</div>
            <Textarea
              adjustHeight
              class='contact-invite-modal__textarea'
              placeholder='e.g. Nice to meet you at the event, let’s stay in touch in the community.'
              newStyle
              onContentChange={(value: string) => this.setState({ customMessage: value })}
              value={customMessage}
            />
          </div>
        </ModalBody>
        <ModalFooter>
          <ButtonControl
            title='Send invite via email'
            newStyle
            onClick={this.sendInvite}
            size='medium'
            variant='brand'
          />
        </ModalFooter>
      </Modal>
    )
  }
}

export default ContactInviteModal
